module.exports = __webpack_public_path__ + "img/Frame 2137_copy2.01feee06.png";